export const newNote = `---\ntitle: \ntags: \nprojects: \n---\n\n`;
export const newDay = `---\ntags: \nprojects: \n---\n\n`;
